/**
 * Versão do aplicativo PWA
 * Esta versão deve ser atualizada sempre que houver mudanças significativas
 */
export const APP_VERSION = '0.3.2';

/**
 * Versão do Service Worker (Cache)
 * Esta versão é usada para invalidar caches antigos
 */
export const SW_CACHE_VERSION = 'v79';

